// League-row helpers. The league array is positional (docs/ODDS_SPECS.md), so anything
// that interprets a field by index belongs here rather than at each call site.

export default {
  // The league kind carried in item[10]: "virtual", "major", or "normal".
  //
  // NORMAL is three wire values: "", null, and the element being absent. Testing for the
  // positive values and defaulting to normal keeps those from being misread.
  // An unrecognised value also falls to "normal": a kind this build predates should still
  // be listed rather than hidden.
  kind(row) {
    const value = row == null ? null : row[10];
    if (value === "virtual") return "virtual";
    if (value === "major") return "major";
    return "normal";
  },

  // Mobile market cards are styled by .m-card.virtual and .virtual .m-card-header (market.css).
  kindClass(kind) {
    if (kind === "virtual") return "virtual";
    if (kind === "major") return "";
    return "";
  }
};
